const close = `
  <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" fill="currentColor" viewBox="0 0 18 17" >
    <path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z" fill="currentColor">
  </svg>
`

const caret = `
  <svg xmlns="http://www.w3.org/2000/svg" width="7" height="12" viewBox="0 0 7 12" fill="none">
    <path d="M0.6875 0.387207L5.5 5.88721L0.6875 11.3872" stroke="#2B2829"/>
  </svg>
`

const play = `
<svg xmlns="http://www.w3.org/2000/svg"
  aria-hidden="true"
  focusable="false"
  class="icon icon-play"
  role="presentation"
  width="15"
  height="16"
  viewBox="0 0 15 16"
  fill="none">
    <path d="M13.4922 8L1 15.1384L1 0.86159L13.4922 8Z" stroke="currentColor"/>
</svg>
`

const pause = `
<svg xmlns="http://www.w3.org/2000/svg"
  aria-hidden="true"
  focusable="false"
  class="icon icon-pause"
  role="presentation"
  viewBox="0 0 16 16"
  width="16"
  height="16">
    <line x1="4" x2="4" y1="0" y2="16" fill="none" stroke="currentColor" stroke-miterlimit="10" stroke-width="2"/>
    <line x1="12" x2="12" y1="0" y2="16" fill="none" stroke="currentColor" stroke-miterlimit="10" stroke-width="2"/>
</svg>
`

export { close, caret, play, pause }
